'use client';

import { Suspense } from 'react';
import BootIntercom from './BoostIntercom';

export default function IntercomWidget({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Suspense fallback={null}>
        <BootIntercom />
      </Suspense>
      {children}
    </>
  );
}
